export default __webpack_public_path__ + "static/media/MySLR_papers_selection.5eac4f50.mp4";